<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Modifier un rendez-vous</div>
</div>
@if (!inProgressAppointment || !inProgressAppointment.site_address || !inProgressAppointment.site_address.buildingId) {
    <div class="w-100 error-message text-center">
        L'adresse d'intervention est introuvable.
        <div class="cta_container text-center">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        </div>
    </div>
}
@if (inProgressAppointment && inProgressAppointment.site_address.buildingId) {
    <div class="col-12 w-100">
        <div class="row">
            <div class="col-auto">
                <strong class="pr-2">Adresse d'intervention:</strong>
            </div>
            @if (inProgressAppointment.site_address.address !== null) {
                <div class="col-auto">
                    <u>{{ inProgressAppointment.site_address.address.name }}</u>
                    <br/>
                    <u>{{ inProgressAppointment.site_address.address.citycode + ' ' + inProgressAppointment.site_address.address.city }}
                        <br/></u>
                </div>
            }
            @if (inProgressAppointment.site_address.address == null && inProgressAppointment.site_address.mediaPostAddress) {
                <div class="col-auto">
                    <u>{{ inProgressAppointment.site_address.mediaPostAddress.streetNumber + ' ' + inProgressAppointment.site_address.mediaPostAddress.streetName }}</u>
                    <br/>
                    <u>{{ inProgressAppointment.site_address.mediaPostAddress.zipCode + ' ' + inProgressAppointment.site_address.mediaPostAddress.city }}
                        <br/></u>
                </div>
            }
        </div>
        <div class="row mt-2">
            <div class="col-auto">
                <strong class="pr-2">Date d'intervention:</strong>
            </div>
            <div class="col-auto">
                Le {{ moment(inProgressAppointment.appointmentDate).format('DD/MM/YYYY') + ' entre ' + formatAppointmentHour(inProgressAppointment.appointmentStartHour) + ' et ' + formatAppointmentHour(inProgressAppointment.appointmentEndHour) }}
            </div>
        </div>
        @if (appointmentsList.length > 0) {
            <div class="row mt-4">
                <div class="col-auto">
                    <strong>Choisissez une date:</strong>
                </div>
            </div>
        }
        @if (appointmentsList.length > 0) {
            <div [class]="'row appointment datepicker-'+environment.data.brand">
                <mat-form-field>
                    <input
                            [value]="selectedAppointment.date"
                            matInput
                            [matDatepicker]="picker"
                            [matDatepickerFilter]="appointmentDateFilter"
                            (dateChange)="setAppointmentDate($event.value)"
                    >
                    <mat-datepicker-toggle matSuffix [for]="picker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        }
        @if (selectedAppointment.date && appointments.length > 0) {
            <div class="row">
                <strong>Sélectionnez un créneau</strong>
            </div>
        }
        <div class="row">
            @for (appointment of appointments; track appointment) {
                <div
                        [className]="appointment.timeSlot == selectedAppointment.timeSlot ?
              environment.data.brand + '-schedule ' + environment.data.brand + '-selected-schedule' :
              environment.data.brand + '-schedule'"
                        (click)="setSelectedAppointment(appointment)"
                >
                    {{ appointment.timeSlot }}
                </div>
            }
        </div>
        <br/><br/>
        <div class="cta_container text-center">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            @if (selectedAppointment.timeSlot && selectedAppointment.date && appointments.length > 0) {
                <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span>
                </button>
            }
        </div>
    </div>
}